export interface ErrorStateProps {
  children: React.ReactNode
}

export const ErrorState = ({ children, ...rest }: ErrorStateProps) => {
  return (
    <div
      className="grid h-auto w-full place-content-center place-items-center gap-3 rounded-lg bg-danger-bg px-8 py-6 text-center text-danger"
      {...rest}
    >
      {children}
    </div>
  )
}
